import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['config']),
  },
  methods: {
    installApp(id, type) {
      return new Promise(async (resolve, reject) => {
        if (!this.$store.getters.isDeviceLinked) {
          this.$confirm(this.$t('GO_TO_LINK_QUESTION')).then(() => {
            this.$router.push('/link');
          });
          reject();
          return;
        }

        const { config } = this.$store.getters;

        if (config.appsync === 'unknown') {
          await this.$confirm(this.$t('UNKNOWN_STATE_NOTICE'))
            .then(() => this.$api.saveConfiguration({ appsync: 'no' }))
            .catch(() => this.$api.saveConfiguration({ appsync: 'yes' }))
            .finally(() => {
              this.$store.dispatch('getConfig', false);
              this.$store.dispatch('getDevices', false);
              this.$notify({ type: 'success', text: this.$t('FEATURE_CONFIGURATION_SAVED') });
            });
        }

        const features = await this.getFeaturesConfig(type);

        this.$api.installApp({
          id, type, features,
        })
          .then(() => {
            this.$confirm(this.$t('INSTALL_APP_CONFIRMATION'))
              .catch(() => {
                this.$router.push('/my/status');
              });
          })
          .catch(([errorCode, errorMessage]) => {
            this.$notify({
              type: 'error',
              text: errorMessage,
            });

            let message = '';
            let link = '';
            switch (errorCode) {
              case 'PRO_REVOKED':
                link = '/my/pro';
                break;
              case 'DEVICE_IS_NOT_PRO_NOR_FREE':
              case 'ERROR_FREE_DEVELOPER_UNSUPPORTED_IOS_VERSION':
                message = 'PRO_OBTAIN_CONFIRM';
                link = '/my/buy';
                break;
              case 'PROTECTION_NOT_VALIDATED':
                message = 'NEED_TO_PROTECT_DEVICE';
                link = 'https://a.appdb.to/revocation-protection.php';
                break;
              default:
                break;
            }
            if (message && link) {
              this.$confirm(this.$t(message)).then(() => this.goToLink(link));
              return;
            }

            if (link) {
              this.goToLink(link);
            }
          })
          .finally(resolve);
      });
    },
    async getFeaturesConfig(type) {
      if (this.config.ask_for_installation_options !== 'yes' || type === 'books') {
        return {};
      }

      const features = await this.$api.getInstallFeatures();
      const config = {};

      // eslint-disable-next-line
      for (const feature of features) {
        if (feature.type === 'string') {
          // eslint-disable-next-line no-await-in-loop
          const answer = await this.$prompt(feature.question, feature.default || '', { yesOrNo: true }).catch(() => '');
          config[`enable_features[${feature.identifier}]`] = answer;
        } else if (feature.type === 'boolean') {
          // eslint-disable-next-line no-await-in-loop
          const answer = await this.$confirm(feature.question, { yesOrNo: true })
            .then(() => 1).catch(() => 0);
          config[`enable_features[${feature.identifier}]`] = answer;
        }
      }

      return config;
    },
    goToLink(url) {
      if (/^\//.test(url)) {
        this.$router.push(url);
        return;
      }

      window.open(url, '_blank');
    },
  },
};
